import { render, staticRenderFns } from "./NoblePermission.vue?vue&type=template&id=2bdb7461&"
import script from "./NoblePermission.vue?vue&type=script&lang=js&"
export * from "./NoblePermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports